import { useFramework } from '@/framework';
import { getAdapter } from '../adapter';
import { useTextEditState } from '../states/text-edit-state';
import { checkHasTextNode, ensureEditAreaHasDefaultStruct } from '../utils';

export const useInputEvent = () => {
    const framework = useFramework();
    const layer = useTextEditState()((state) => state.editingLayer);

    const handleInput = (event: React.FormEvent<HTMLDivElement>) => {
        if (!layer) return;

        const currentTarget = event.currentTarget as HTMLDivElement;
        const { inputType } = event.nativeEvent as InputEvent;

        if (inputType === 'deleteContentBackward') {
            const hasTextNode = checkHasTextNode(currentTarget);
            if (!hasTextNode) ensureEditAreaHasDefaultStruct(currentTarget);
        }

        const adapter = getAdapter(layer.layerType);
        if (adapter) {
            adapter.onUpdate(framework, currentTarget, layer, {
                inputType,
            });
        }
    };

    return {
        handleInput,
    };
};
